<scf-v2-main-s4-nowork
  *ngIf="hasNoWorkTasks()"
  [scfMaster]="scfMaster"
  [disabled]="
    disabled &&
    scfMaster?.status != formStatusEnum.Active &&
    scfMaster?.status != formStatusEnum.HoldPoint
  "
  [privileges]="privileges"
  [status]="status"
>
</scf-v2-main-s4-nowork>

<scf-v2-main-s4-holdpoints
  *ngIf="hasHoldPointTasks()"
  [scfMaster]="scfMaster"
  [disabled]="disabled"
  [privileges]="privileges"
  [status]="status"
  (changed)="changed.emit($event)"
>
</scf-v2-main-s4-holdpoints>
<div class="pt-2 mt-3" *ngIf="signatures?.length">
  <h5 class="section-title">Work Complete</h5>

  <div class="row px-3 justify-content-center">
    <div
      class="col px-1 pb-2"
      id="{{ s.disapproveAction }}"
      *ngFor="let s of signatures"
    >
      <button-signature
        #btnSign
        [roleId]="s.roles"
        [roleCodes]="s.roleCodes"
        [user]="s.approvedBy"
        [title]="s.name"
        [disabled]="s.disabled"
        [value]="s.approved"
        [showApprove]="s.approveAction"
        [showDisapprove]="s.disapproveAction"
        [showUnapprove]="s.unapproveAction"
        [date]="s.approvedOn"
        [showTestApprove]="canTestSign(s)"
        (approve)="approve(s)"
        (disapprove)="disapprove(s, $event)"
        (unapprove)="unapprove(s)"
        (testApprove)="testSign(s)"
        [enabled]="s.enabled"
      ></button-signature>
    </div>
  </div>
</div>
